import { useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchPublicStatsParams,
  selectPublicStats,
  selectPublicStatsLoading,
  selectPublicStatsState,
  useFetchPublicStatsQuery,
} from '../actions/fetchPublicStats';
import { REFETCH_STATS_INTERVAL } from '../const';

export interface IUsePublicStatsProps
  extends IFetchPublicStatsParams,
    IUseQueryProps {}

export const usePublicStats = ({
  blockchains,
  groupBy,
  limit,
  metrics,
  skipFetching,
  timeframe,
  timeframeShift,
}: IUsePublicStatsProps) => {
  const params = useMemo(
    (): IFetchPublicStatsParams => ({
      blockchains,
      groupBy,
      limit,
      metrics,
      timeframe,
      timeframeShift,
    }),
    [blockchains, groupBy, limit, metrics, timeframe, timeframeShift],
  );

  useFetchPublicStatsQuery(getQueryParams({ params, skipFetching }), {
    refetchOnMountOrArgChange: REFETCH_STATS_INTERVAL,
  });

  const publicStats = useAppSelector(state => selectPublicStats(state, params));

  const loading = useAppSelector(state =>
    selectPublicStatsLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectPublicStatsState(storeState, params),
  );

  return { loading, params, publicStats, state };
};
